import { HttpErrorResponse } from '@angular/common/http';
import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { InformeCanjeMedico } from 'src/app/models/informe-canjes-medicos.interface';
import { Paginar } from 'src/app/models/http-paginacion.interface';
import { AdministradorService } from 'src/app/services/administrador.service';

@Component({
  selector: 'app-administrador-informe-canjes-medicos',
  templateUrl: './administrador-informe-canjes-medicos.component.html',
  styleUrls: ['./administrador-informe-canjes-medicos.component.scss'],
  providers: [MessageService]
})
export class AdministradorInformeCanjesMedicosComponent {
  canjesMedicos: InformeCanjeMedico[] = [];
  currentPage: Paginar = { page: 0, first: 0, rows: 10, pageCount: 0 };
  totalItems: number = 0;

  constructor(
    private administradorService: AdministradorService,
    private messageService: MessageService
  ) {
    this.getCanjesMedicos();
  }

  get totalPaginas(): number {
    return Math.ceil(this.canjesMedicos.length / this.currentPage.rows);
  }

  get paginacionCanjesMedicos(): InformeCanjeMedico[] {
    const startIndex = this.currentPage.page * this.currentPage.rows;
    return this.canjesMedicos.slice(startIndex, startIndex + this.currentPage.rows);
  }

  getCanjesMedicos(): void {
    this.administradorService.getInfoCanjesMedicos()
      .subscribe({
        next: (resp) => {
          this.canjesMedicos = resp.datos ?? [];
          this.totalItems = this.canjesMedicos.length;
        },
        error: (err: HttpErrorResponse) => {
          console.log(err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.message ?? 'No se pudo cargar el informe de canjes de medicos'
          });
        }
      });
  }

  onPageChange(event: any): void {
    this.currentPage = <Paginar>event;
  }

  exportExcel(): void {
    const EXCEL_EXTENSION = '.xlsx';
    const canjesMedicos = this.fullInformeCanjesMedicos();
    const titulo = [{ campo: 'Informe de canjes de Medicos', fecha: new Date().toLocaleDateString() }];
    const fileName = 'informe-canjes-medicos';

    import('xlsx').then((XLSX) => {
      const ws = XLSX.utils.json_to_sheet([]);
      XLSX.utils.sheet_add_json(ws, titulo, { origin: 'A2', skipHeader: true });
      XLSX.utils.sheet_add_json(ws, canjesMedicos, { origin: 'A4' });
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, 'canjes-medicos');
      XLSX.writeFile(wb, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
    });
  }

  fullInformeCanjesMedicos(): Record<string, string | number>[] {
    return this.canjesMedicos.map((item) => {
      return {
        Medico: item.Nombre,
        'Puntos generados': item.PuntosGenerados,
        'Productos aplicados': item.CantidadProductosAplicados,
        'Puntos canjeados': item.PuntosCanjeados,
        'Canjes generados y pagados': item.NumerodeCanjesGeneradosyPagados,
        Saldo: item.Saldo
      };
    });
  }
}
